"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";
import { LucideProps } from "lucide-react";
import { useMemo } from "react";
interface AnimatedIconProps {
  name: string;
  className?: string;
}
export function AnimatedIcon(t0) {
  const $ = _c(13);
  const {
    name,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const Icon = LucideIcons[name as keyof typeof LucideIcons] as React.ComponentType<LucideProps>;
  const randomDelay = Math.random() * 2;
  const randomDuration = 3 + Math.random() * 2;
  if (!Icon) {
    return null;
  }
  const t2 = `relative w-full h-full flex items-center justify-center perspective-500 ${className}`;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      y: [-4, 4, -4],
      rotateX: [0, 5, 0],
      rotateY: [0, 5, 0]
    };
    t4 = {
      duration: randomDuration,
      repeat: Infinity,
      ease: "easeInOut",
      delay: randomDelay
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      scale: 1.2,
      rotateZ: 5,
      transition: {
        duration: 0.2
      }
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== Icon) {
    t6 = <Icon className="w-full h-full text-foreground drop-shadow-xl" strokeWidth={1.5} />;
    $[3] = Icon;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== Icon) {
    t7 = <div className="absolute inset-0 text-primary/30 blur-sm transform translate-y-2 scale-95 -z-10"><Icon className="w-full h-full" strokeWidth={3} /></div>;
    $[5] = Icon;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <motion.div className="relative z-10" animate={t3} transition={t4} whileHover={t5}>{t6}{t7}</motion.div>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t2 || $[11] !== t8) {
    t9 = <div className={t2}>{t8}</div>;
    $[10] = t2;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}